export default __webpack_public_path__ + "static/saasboomi_thumb-ff26f84fd669b34a6aebdafbdc920072.png";